import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addOriginalTabs, getForm } from "../../Core/features/formSlice";
import {
  addTabsData,
  setCurrentTab,
  setCurrentQuestion,
  setTabsToDisplay,
  removeTabsData,
  setAnswers,
  deleteTabQuestion,
  resetTabsData,
} from "../../Core/features/tabsSlice";
import backButton from "../../Assets/img/previous.svg";
import Tabs from "../../Components/Tabs";
import Questions from "../../Components/Questions";
import Checkout from "../../Components/Checkout";
import ReviewDetails from "../../Components/ReviewDetails";
import StartScreen from "../../Components/StartScreen";
import ProductRec from "../../Components/ProductRec";
import Loader from "../../Components/Loader";
import { toast } from "react-toastify";
import { findMatchingQuestionId, staticTabs, toastStyle } from "../../Utils";
import { removeProduct } from "../../Core/features/checkoutSlice";

const Dashboard = () => {
  const dispatch = useDispatch();
  const { form, originalTabs } = useSelector((state) => state.FormState);
  const { tabs, tabsToDisplay, currentTab, currentQuestion, answers } =
    useSelector((state) => state.TabsState);
  const { productInfo } = useSelector((state) => state.CheckoutState);
  // const [savedCurrentAnswers, setSavedCurrentAnswers] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [showStartScreen, setShowStartScreen] = useState(() => {
    // Check sessionStorage to determine if the user has already started
    const hasStarted = sessionStorage.getItem("hasStartedQuiz");
    return hasStarted !== "true"; // Show StartScreen if not started
  });
  console.log(form, "form");
  useEffect(() => {
    if (form && tabsToDisplay?.length == 0) {
      // Add hidden property to Tax and Bookkeeping tabs
      const updatedTabs = form?.map((tab) => {
        if (tab?.tab_condtions?.length > 0) {
          return { ...tab, isHidden: true };
        }
        return tab;
      });
      dispatch(addOriginalTabs([...updatedTabs]));
      const data = dispatch(
        setTabsToDisplay([...updatedTabs, ...staticTabs])
      ).payload;
      if (data) {
        setIsLoading(false);
      }
    }
  }, [form]);

  useEffect(() => {
    if (form && tabsToDisplay.length > 0) {
      setIsLoading(true);
      const newAddedTabs = form?.filter(
        ({ tab_id: id1 }) =>
          !originalTabs?.some(({ tab_id: id2 }) => id2 === id1)
      );
      const removedTabs = originalTabs?.filter(
        ({ tab_id: id1 }) => !form?.some(({ tab_id: id2 }) => id2 === id1)
      );
      if (newAddedTabs?.length > 0 || removedTabs?.length > 0) {
        dispatch({ type: "RESET_STATE" });
        handleStart("true");
        setTimeout(() => {
          setIsLoading(false);
        }, 1500);
      } else {
        const updatedDisplayTabs = form.map((formTab) => {
          const existingTab = tabsToDisplay.find(
            (displayTab) => displayTab.tab_id === formTab.tab_id
          );
          let tabs =
            existingTab && existingTab?.hasOwnProperty("isHidden")
              ? {
                ...formTab,
                isHidden: existingTab.isHidden, // Preserve or default to false
              }
              : {
                ...formTab,
              };
          return tabs;
        });

        dispatch(setTabsToDisplay([...updatedDisplayTabs, ...staticTabs]));
        setTimeout(() => {
          setIsLoading(false);
        }, 1500);
      }
    }
  }, [form]);

  useEffect(() => {
    if (!form || form.length == 0) {
      setIsLoading(true);
    }
    dispatch(getForm());
  }, [showStartScreen]);
  console.log(answers, "answers");
  // const shouldDisplayQuestion = (question, tabIndex) => {
  //   console.log(question, "previous question")
  //   if (!question?.question_condtions || question?.question_condtions?.length === 0) {
  //     return true;
  //   }

  //   return question?.question_condtions?.some((condition) => {
  //     const tabId = tabsToDisplay[tabIndex]?.tab_id;
  //     const tabAnswers = answers[tabId] || [];
  //     const relatedAnswer = tabAnswers?.find((q) => q?.question_id === condition?.id);
  //     console.log(tabAnswers, "tabAnswers")
  //     return relatedAnswer && relatedAnswer?.answer === condition?.correct_option;
  //   });
  // };

  const shouldDisplayQuestion = (question, tabIndex) => {
    if (
      !question?.question_condtions ||
      question?.question_condtions?.length === 0
    ) {
      return true;
    }
    console.log(question?.question_condtions, "Current Question Conditions");

    return question?.question_condtions?.some((condition) => {
      for (let i = 0; i <= tabIndex; i++) {
        const tabId = tabsToDisplay[i]?.tab_id;
        const tabAnswers =
          tabs?.find((tab) => tab?.tab_id === tabId)?.questions || [];
        console.log(tabAnswers, "tabAnswers");
        const relatedAnswer = tabAnswers?.find(
          (q) => q?.question_id === condition?.id
        );
        console.log(condition, "condition");
        if (
          relatedAnswer &&
          relatedAnswer?.answer === condition?.correct_option
        ) {
          console.log(relatedAnswer, "relatedAnswer that matched");
          return true;
        }
      }
      return false;
    });
  };

  console.log(tabsToDisplay, "tabsToDisplay");
  const handleNext = () => {
    const currentTabData = tabsToDisplay[currentTab];
    const totalQuestions = currentTabData?.questions?.length;

    const isStaticTab = staticTabs.some(
      (tab) => tab.tab_name === currentTabData?.tab_name
    );
    if (isStaticTab && currentTab < tabsToDisplay?.length - 1) {
      if (
        (tabsToDisplay[currentTab]?.tab_id === 2 &&
          productInfo &&
          !productInfo?.contact_us) ||
        (tabsToDisplay[currentTab]?.tab_id === 2 && !Array.isArray(productInfo))
      ) {
        const updatedTabs = tabsToDisplay?.map((tab) => {
          if (tab?.tab_id === 3) {
            return { ...tab, isHidden: false };
          }
          return tab;
        });

        dispatch(setTabsToDisplay([...updatedTabs]));
      }
      dispatch(setCurrentTab(currentTab + 1));
      return;
    }
    const currentQuestionId = currentTabData?.questions[currentQuestion]?.id;
    const tabAnswers =
      tabs?.find((tab) => tab?.tab_id === currentTabData?.tab_id)?.questions ||
      [];
    const isCurrentQuestionAnswered = tabAnswers?.some(
      (q) => q?.question_id === currentQuestionId
    );

    if (!isCurrentQuestionAnswered) {
      toast.error(
        "Please answer the current question before proceeding.",
        toastStyle
      );
      return;
    }
    let nextQuestionIndex = currentQuestion + 1;
    console.log(
      currentTabData?.questions[nextQuestionIndex],
      "currentTabData?.questions[nextQuestionIndex]"
    );
    console.log(nextQuestionIndex, "nextQuestionIndex");
    while (
      nextQuestionIndex < totalQuestions &&
      !shouldDisplayQuestion(
        currentTabData?.questions[nextQuestionIndex],
        currentTab
      )
    ) {
      nextQuestionIndex++;
    }
    console.log(nextQuestionIndex, "nextQuestionIndex");
    if (nextQuestionIndex < totalQuestions) {
      dispatch(setCurrentQuestion(nextQuestionIndex));
      return;
    }

    if (currentTab < tabsToDisplay?.length - 1) {
      let updatedTabsToDisplay = [...tabsToDisplay];
      const matchedTabs = processTabConditions(updatedTabsToDisplay, tabs);

      if (matchedTabs && matchedTabs.length > 0) {
        matchedTabs.forEach((matchedTab) => {
          // Find the corresponding tab in the displayTabs array
          updatedTabsToDisplay = updatedTabsToDisplay?.map((tab, index) => {
            if (tab.tab_id === matchedTab.tab_id) {
              return { ...tab, isHidden: false };
            }
            return tab;
          });
        });
        dispatch(setTabsToDisplay(updatedTabsToDisplay));
      }

      let nextTabIndex = currentTab + 1;
      while (
        nextTabIndex < tabsToDisplay.length &&
        updatedTabsToDisplay[nextTabIndex]?.isHidden
      ) {
        nextTabIndex++;
      }
      if (nextTabIndex < tabsToDisplay.length) {
        dispatch(setCurrentTab(nextTabIndex));
        // QUESTION CONDITIONING
        const totalQuestionsOfNextTab =
          tabsToDisplay[nextTabIndex]?.questions?.length;
        let displayQuestionIndex = 0;
        console.log(totalQuestionsOfNextTab, "totalQuestionsOfNextTab");
        console.log(tabsToDisplay[nextTabIndex], "tabsToDisplay[nextTabIndex]");
        while (
          displayQuestionIndex < totalQuestionsOfNextTab &&
          !shouldDisplayQuestion(
            tabsToDisplay[nextTabIndex]?.questions[displayQuestionIndex],
            nextTabIndex
          )
        ) {
          displayQuestionIndex++;
        }
        if (displayQuestionIndex <= totalQuestionsOfNextTab) {
          console.log(
            displayQuestionIndex,
            "displayQuestionIndex inside while"
          );
          dispatch(setCurrentQuestion(displayQuestionIndex));
          return;
        }
      }
    } else {
      toast.success("You have completed the form.", toastStyle);
    }
  };

  const handlePrevious = () => {
    let prevQuestionIndex = currentQuestion - 1;
    const currentQuestionObject =
      tabsToDisplay[currentTab]?.questions[currentQuestion];
    const tabId = tabsToDisplay[currentTab]?.tab_id;
    console.log(currentQuestion, "currentQuestion");
    dispatch(
      deleteTabQuestion({
        tab_id: tabId,
        question_id: currentQuestionObject?.id,
      })
    );
    while (
      prevQuestionIndex >= 0 &&
      !shouldDisplayQuestion(
        tabsToDisplay[currentTab]?.questions[prevQuestionIndex],
        currentTab
      )
    ) {
      prevQuestionIndex--;
    }

    if (prevQuestionIndex >= 0) {
      dispatch(setCurrentQuestion(prevQuestionIndex));
      return;
    } else if (currentTab > 0) {
      let updatedTabs;
      updatedTabs = updateHiddenTabsForPrevious(currentTab);

      dispatch(setTabsToDisplay(updatedTabs));
      let prevTabIndex = currentTab - 1;
      while (prevTabIndex >= 0 && updatedTabs[prevTabIndex]?.isHidden) {
        prevTabIndex--;
      }
      if (updatedTabs[currentTab]?.tab_name == "Product Reccomendations") {
        dispatch(removeProduct());
      }

      if (prevTabIndex >= 0) {
        const newPrevTab = updatedTabs[prevTabIndex];
        dispatch(setCurrentTab(prevTabIndex));
        let prevTabLastQuestionIndex = newPrevTab?.questions?.length - 1;
        console.log(newPrevTab, "newPrevTab");
        console.log(prevTabLastQuestionIndex, "prevTabLastQuestionIndex");

        // Iterate backward through the questions of the previous tab to find the last one to display
        while (prevTabLastQuestionIndex >= 0) {
          if (
            shouldDisplayQuestion(
              newPrevTab?.questions[prevTabLastQuestionIndex],
              prevTabIndex
            )
          ) {
            break;
          }
          prevTabLastQuestionIndex--;
        }

        // Set the current question to the last valid question in the previous tab
        dispatch(
          setCurrentQuestion(
            prevTabLastQuestionIndex >= 0 ? prevTabLastQuestionIndex : 0
          )
        );
      }
    }
  };

  const saveAnswer = (questionId, answer) => {
    const tabId = tabsToDisplay[currentTab]?.tab_id;
    const updatedTabAnswers = [
      ...(answers[tabId] || [])?.filter((q) => q?.question_id !== questionId),
      { question_id: questionId, answer },
    ];
    dispatch(
      setAnswers({
        [tabId]: updatedTabAnswers,
      })
    );
    dispatch(
      addTabsData({
        tab_id: tabId,
        question_id: questionId,
        answer: answer,
      })
    );
  };

  const handleStart = (started) => {
    setShowStartScreen(!showStartScreen); // Hide the Start Screen
    sessionStorage.setItem("hasStartedQuiz", started); // Save state to sessionStorage
  };

  const handleTabChange = (tab_id, question_id) => {
    //This work is for updating the tabs state in redux

    let tabsCopy = JSON.parse(JSON.stringify(tabs));
    const tabIndexInTabs = tabsCopy?.findIndex(
      (item, index) => item?.tab_id === tab_id
    );
    const questionIndexInTabs = tabsCopy[tabIndexInTabs]?.questions?.findIndex(
      (item, index) => item?.question_id === question_id
    );
    let questionsToPersist = tabsCopy[tabIndexInTabs]?.questions;
    questionsToPersist = questionsToPersist?.splice(0, questionIndexInTabs);
    const tabsToPersist = tabsCopy?.splice(0, tabIndexInTabs);
    let displayTabsAfterOnChange = [
      ...tabsToPersist,
      { tab_id: tabs[tabIndexInTabs]?.tab_id, questions: questionsToPersist },
    ];
    dispatch(resetTabsData(displayTabsAfterOnChange));

    //This work is for displaying question and tabs
    const tabIndexInDisplayTabs = tabsToDisplay.findIndex(
      (tab) => tab.tab_id === tab_id
    );
    if (tabIndexInDisplayTabs === -1) {
      return;
    }
    const selectedTab = tabsToDisplay[tabIndexInDisplayTabs];
    let updatedTabs = updateHiddenTabsForOnChange(tabIndexInDisplayTabs, true);
    dispatch(setTabsToDisplay(updatedTabs)); // Dispatch action to update tabs display if required
    console.log(updatedTabs, "updatedTabs----updatedTabs");
    dispatch(setCurrentTab(tabIndexInDisplayTabs));
    const questionIndexInDisplayTabs = selectedTab?.questions?.findIndex(
      (question) => question.id === question_id
    );
    if (questionIndexInDisplayTabs !== -1) {
      dispatch(setCurrentQuestion(questionIndexInDisplayTabs)); // Dispatch action to update question if required
    }
  };

  const processTabConditions = () => {
    const matchedTabs = [];
    const currentTabBeingDisplayed = tabs?.filter(
      (ct, index) => ct?.tab_id === tabsToDisplay[currentTab]?.tab_id
    )[0]; // 2. Find the matching tab in the tabs array

    tabsToDisplay.forEach((displayTab) => {
      if (displayTab.tab_condtions && displayTab.tab_condtions.length > 0) {
        if (currentTabBeingDisplayed) {
          const matchedConditions = [];

          displayTab.tab_condtions.forEach((condition) => {
            const matchingQuestion = currentTabBeingDisplayed?.questions?.find(
              (question) => question.question_id === condition.id
            );
            if (
              matchingQuestion &&
              matchingQuestion.answer === condition.correct_option
            ) {
              matchedConditions.push(condition);
            }
          });
          if (matchedConditions.length > 0) {
            matchedTabs.push({
              tab_id: displayTab.tab_id,
              tab_name: displayTab.tab_name,
              matchedConditions,
            });
          }
        }
      }
    });

    return matchedTabs;
  };

  const updateHiddenTabsForPrevious = (currentTabIndex) => {
    let newTabs = JSON.parse(JSON.stringify(tabsToDisplay));
    const currentTabData = newTabs[currentTabIndex];
    let shouldUpdate = false;
    for (let i = currentTabIndex - 1; i >= 0; i--) {
      const tab = newTabs[i];
      if (tab.isHidden === true || !("isHidden" in tab)) {
        shouldUpdate = true;
        break;
      } else if (tab.isHidden === false) {
        shouldUpdate = false;
        break;
      }
    }
    if (shouldUpdate) {
      for (let i = currentTabIndex; i < newTabs.length; i++) {
        if ("isHidden" in newTabs[i] && newTabs[i].isHidden === false) {
          newTabs[i].isHidden = true;
          dispatch(removeTabsData(currentTabData?.tab_id));
        }
      }
    }
    return newTabs;
  };
  const updateHiddenTabsForOnChange = (redirectionTabIndex) => {
    let newTabs = JSON.parse(JSON.stringify(tabsToDisplay));
    const currentTabData = newTabs[redirectionTabIndex];
    console.log(currentTabData, "currentTabData");
    if (!("isHidden" in currentTabData)) {
      for (let i = redirectionTabIndex + 1; i < newTabs.length; i++) {
        if ("isHidden" in newTabs[i] && newTabs[i].isHidden === false) {
          newTabs[i].isHidden = true;
        }
      }
    }
    return newTabs;
  };
  return (
    <>
      {showStartScreen ? (
        <StartScreen handleStart={handleStart} /> // Render StartScreen if showStartScreen is true
      ) : (
        <div className="form_wrapper">
          <div className="main_wrapper">
            {isLoading ? (
              <Loader />
            ) : (
              <div className="step-form">
                <Tabs
                  tabsToDisplay={tabsToDisplay}
                  tab_name={tabsToDisplay[currentTab]?.tab_name}
                  currentTab={currentTab}
                  tabs={tabsToDisplay}
                />
                <div className="previous_btn_wrapper">
                  <button
                    onClick={handlePrevious}
                    id="prevBtn"
                    style={{
                      display:
                        currentTab === 0 && currentQuestion === 0
                          ? "none"
                          : "flex",
                    }}
                    disabled={currentTab === 0 && currentQuestion === 0}
                  >
                    <div class="back_icon">
                      <img src={backButton} alt="Back" />
                    </div>
                    Previous
                  </button>
                </div>
                <div className="form-content">
                  {tabsToDisplay &&
                    tabsToDisplay[currentTab]?.questions &&
                    tabsToDisplay[currentTab]?.questions?.[currentQuestion] && (
                      <Questions
                        key={currentQuestion}
                        currentTab={tabsToDisplay[currentTab]}
                        currentQuestion={currentQuestion}
                        item={
                          tabsToDisplay[currentTab]?.questions[currentQuestion]
                        }
                        saveAnswer={saveAnswer}
                        answers={answers}
                      // savedCurrentAnswers={savedCurrentAnswers}
                      />
                    )}
                  {tabsToDisplay && tabsToDisplay[currentTab]?.tab_id == 1 && (
                    <ReviewDetails
                      handleTabChange={handleTabChange}
                      displayTabs={tabsToDisplay}
                      tabs={tabs}
                    />
                  )}
                  {tabsToDisplay && tabsToDisplay[currentTab]?.tab_id == 2 && (
                    <ProductRec
                      handleNext={handleNext}
                      currentTab={currentTab}
                      tab_name={tabsToDisplay[currentTab]?.tab_name}
                    />
                  )}
                  {tabsToDisplay && tabsToDisplay[currentTab]?.tab_id == 3 && (
                    <Checkout handleStart={handleStart} />
                  )}
                </div>
                {tabsToDisplay &&
                  tabsToDisplay?.length > 0 &&
                  tabsToDisplay[currentTab]?.tab_name !==
                  "Product Reccomendations" &&
                  tabsToDisplay[currentTab]?.tab_name !== "Checkout" && (
                    <div className="buttons_group">
                      <button onClick={handleNext} id="nextBtn">
                        {tabsToDisplay &&
                          tabsToDisplay[currentTab] &&
                          tabsToDisplay[currentTab]?.questions &&
                          currentQuestion ===
                          tabsToDisplay[currentTab]?.questions?.length - 1 &&
                          currentTab === tabsToDisplay?.length - 1
                          ? "Finish"
                          : tabsToDisplay[currentTab]?.tab_name == "REVIEW"
                            ? "View Recommended Product(s)"
                            : "Next"}
                      </button>
                    </div>
                  )}
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default Dashboard;
